import React from "react";
import "./Earnings.css";

import useEarnings from "./hooks/useEarnings";

import EarningsSummary from "./components/EarningsSummary";
import EarningsChart from "./components/EarningsChart";
import EarningsTable from "./components/EarningsTable";
import SettlementCard from "./components/SettlementCard";

const Earnings = () => {
  const {
    summary,
    analytics,
    transactions,
    pendingSettlements,
    loading,
    error,
  } = useEarnings();

  if (loading) {
    return (
      <div className="earnings-loading">
        Loading Earnings...
      </div>
    );
  }

  if (error) {
    return (
      <div className="earnings-error">
        {error}
      </div>
    );
  }

  return (
    <div className="earnings-page">

      <div className="earnings-header">
        <h1>💰 Earnings Dashboard</h1>
        <p>
          View your earnings, transactions,
          settlements and business growth.
        </p>
      </div>

      <EarningsSummary summary={summary} />

      <div className="earnings-middle">

        <div className="earnings-chart-section">
          <EarningsChart
            analytics={analytics}
          />
        </div>

        <div className="earnings-settlement-section">
          <SettlementCard
            summary={summary}
            pendingSettlements={
              pendingSettlements
            }
          />
        </div>

      </div>

      <div className="earnings-table-section">

        <EarningsTable
          transactions={transactions}
        />

      </div>

    </div>
  );
};

export default Earnings;